import { differenceInYears, subYears, format } from 'date-fns';
import { ure_dates } from '../../constants/underwriting';

const months = Array.from({ length: 12 }, (e, i) => {
  return new Date(null, i + 1, null).toLocaleDateString('en', {
    month: 'long',
  });
});

const monthsShort = Array.from({ length: 12 }, (e, i) => {
  return new Date(null, i + 1, null).toLocaleDateString('en', {
    month: 'short',
  });
});

export const convertDateStrToFormat = (string) => {
  try {
    if (isNaN(Date.parse(string))) {
      throw new Error('Invalid date');
    }
    const date = new Date(string);
    return format(date, 'dd/MM/yyyy');
  } catch {
    return null;
  }
};

export const isValidYear = (value) => {
  return value.match(ure_dates.YEAR_SCOPE_REGEX) !== null;
};

export const isValidMonth = (value) => {
  if (months.indexOf(value) !== -1) return true;
  if (monthsShort.indexOf(value) !== -1) return true;
  if (value.match(ure_dates.MONTH_SCOPE_REGEX) !== null) return true;
  return false;
};

export const splitDateValue = (value) => {
  const dateArray = value ? value.split(' ') : '';
  if (dateArray.length === 2) {
    return { month: dateArray[0], year: dateArray[1] };
  }
  if (dateArray.length === 1) {
    return { month: null, year: dateArray[0] };
  }
  return { month: null, year: null };
};

export const getAge = (dateOfBirth) => {
  try {
    return dateOfBirth
      ? differenceInYears(new Date(), new Date(dateOfBirth))
      : null;
  } catch {
    return null;
  }
};

export const getDateOfBirthFromAge = (age) => {
  return subYears(new Date(), age);
};

export const formatDate = (date) => {
  try {
    return format(new Date(date), 'dd/MM/yyyy');
  } catch {
    return date;
  }
};

export const formatDocumentDate = (date) => {
  try {
    return format(new Date(date), 'yyyyMMdd');
  } catch {
    return date;
  }
};

export const formatTime = (date) => {
  try {
    return format(new Date(date), 'HH:mm');
  } catch {
    return date;
  }
};
